export default __webpack_public_path__ + "static/media/favicon.670c8fbf.png";